<template>
  <div>
    <el-dialog v-dialogDrag :title="title" :visible.sync="isDialog" width="700px" @opened="getConfigs"
               @close="clearFun('config')" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form size="small" :model="config" ref="config" :rules="rules" label-width="120px">
        <el-form-item prop="id" style="display:none;">
          <el-input v-model="config.id"/>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="编码：" prop="code">
              <el-input v-model="config.code"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="config.name"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="值：" prop="value">
              <el-input v-model="config.value"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序：" prop="sort">
              <el-input v-model="config.sort" placeholder="输入大于等于0的数字" maxlength="11"
                        oninput="value=value.replace(/[^\d]/g,'')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="config.parentId === 965">
          <el-col :span="12">
            <el-form-item label="默认图标：" prop="iconUrl">
              <image-upload ref="path" :url="config.iconUrl" :isFull="true" :on-change="upload" width="120px"
                            height="120px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选中图标：" prop="extraField">
              <image-upload ref="path" :url="config.extraField" :isFull="true" :on-change="updateSelect" width="120px"
                            height="120px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="父级：" prop="parentId">
              <el-cascader v-model="config.parentId" :options="configs"
                           :props="{value:'id',label:'name',checkStrictly:true,emitPath:false}" :show-all-levels="false"
                           placeholder="请选择父级" class="width-full" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：" prop="remark">
              <el-input type="textarea" v-model="config.remark" maxlength="200" placeholder="请输入内容" rows="3"
                        show-word-limit/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="isDialog = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="submitFun('config')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ImageUpload from '@/views/models/ImageUpload'

export default {
  name: 'AddOrUpdate',
  components: {ImageUpload},
  props: {
    //列表刷新
    refresh: {
      type: Function
    }
  },
  data () {
    return {
      //标题
      title: '新增',
      //是否打开弹窗
      isDialog: false,
      //数据
      config: {},
      //验证规则
      rules: {
        code: [{
          required: true,
          message: '请输入编码',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        value: [{
          required: true,
          message: '请输入数据值',
          trigger: 'blur'
        }]
      },
      //父级数据选择
      configs: []
    }
  },
  methods: {
    //图标上传
    upload: function (file) {
      let form = new FormData()
      form.append('path', 'icon')
      form.append('file', file.raw)
      //上传文件
      this.$axios({
        method: 'post',
        url: '/fileUpload/upload',
        data: form,
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(res => {
        //图标地址
        this.config.iconUrl = res ? res.fullPath : null
      })
    },
    updateSelect: function (file) {
      let form = new FormData()
      form.append('path', 'icon')
      form.append('file', file.raw)
      //上传文件
      this.$axios({
        method: 'post',
        url: '/fileUpload/upload',
        data: form,
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(res => {
        //图标地址
        this.config.extraField = res ? res.fullPath : null
      })
    },
    //提交
    submitFun: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //数据提交保存
          this.$axios({
            method: 'post',
            url: '/sysConfig/saveOrUpdate',
            data: this.config
          }).then(response => {
            this.refresh()
            this.isDialog = false
            this.$message.success('保存成功~')
          })
        } else {
          return false
        }
      })
    },
    //清除表单数据
    clearFun: function (formName) {
      this.$refs[formName].resetFields()
      this.config = {}
    },
    //获取父级数据
    getConfigs: function () {
      this.$axios.get('/sysConfig/getAll').then(response => {
        this.configs = this.$utils.convertTree(response)
      })
    }
  }
}
</script>

<style scoped>
.width-full {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/config/AddOrUpdate.vue